import { Navigate, useLocation } from "react-router-dom";
import { postMessage } from "../utils/helper";

const ScanResult = () => {
  const { state } = useLocation();

  if (!state?.result?.workflow_id) {
    return <Navigate to="/" replace />;
  }

  return (
    <section className="min-h-screen flex flex-col items-center justify-center px-8 py-12 text-center text-white bg-primary">

      <div
        className="w-24 h-24 rounded-full flex items-center justify-center mb-8"
        style={{ background: "rgba(34,197,94,0.15)", border: "2px solid rgba(34,197,94,0.4)" }}>
        <svg
          className="w-12 h-12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="rgb(74,222,128)"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round">
          <path d="M5 13l4 4L19 7" />
        </svg>
      </div>

      <h2 className="text-2xl font-bold mb-4">Submission Successful</h2>

      <p className="text-base leading-relaxed" style={{ color: "rgba(255,255,255,0.75)" }}>
        Thank you for completing the verification process. We have captured your response and your application will be processed further.
      </p>

      <p className="mt-4 text-sm" style={{ color: "rgba(255,255,255,0.5)" }}>
        In case of any additional requirement, we will get in touch with you.
      </p>


      <button
        type="button"
        onClick={() => postMessage("success", "scan-result")}
        className="mt-12 w-full max-w-xs px-5 py-3 rounded-full bg-gradient text-white font-medium shadow-lg">
        Done
      </button>
    </section>
  );
};

export default ScanResult;
